import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../globals/data'
import { TwinDictionary } from '../globals/dictionary'
import { setVariablesToCurrentPage } from '../reducers/reduxDispatch'

interface UseBasicDataParams {
    params: TwinDictionary
    url: string
    variableToCurrentPage?: string | string[]
    doPetition?: boolean
}

export const useBasicData = ({ params, url, variableToCurrentPage, doPetition = true }: UseBasicDataParams) => {
    const [basicData, setBasicData] = useState<TwinDictionary | null>(null)

    const paramsString = JSON.stringify(params)
    const variableToCurrentPageStr = JSON.stringify(Array.isArray(variableToCurrentPage) ? variableToCurrentPage : [variableToCurrentPage])
    const getData = useCallback(async () => {
        const paramsParsed = JSON.parse(paramsString)
        const variableToCurrentPageParsed = JSON.parse(variableToCurrentPageStr)
        const myData = await twinFetchPostJSON(url, {
            ...paramsParsed
        })
        if (myData) {
            setBasicData(myData)
            if (variableToCurrentPageParsed && myData) {
                let myVarArray = []
                for (const element of variableToCurrentPageParsed) {
                    if (myData[element]){
                        myVarArray.push(myData[element])
                    }
                }
                if(myVarArray.length){
                    setVariablesToCurrentPage([myVarArray.join(' - ')])
                }
            }
        }
    }, [paramsString, variableToCurrentPageStr, url])

    useEffect(() => {
        if (doPetition) {
            getData()
        }
    }, [getData, doPetition])

    return { basicData, getData }
}